export default __webpack_public_path__ + "static/media/Gida of the Bloodmoon.3da5e8c7.jpg";